// Collection Header Row JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Initialize the sort dropdown
  initSortDropdown();

  // Initialize the search functionality
  initSearchFunctionality();
});

function initSortDropdown() {
  const sortButton = document.getElementById('sortDropdownButton');
  const sortDropdownMenu = document.getElementById('sortDropdownMenu');
  const sortOptions = document.querySelectorAll('.sort-option');
  const sortSelect = document.getElementById('SortBy');
  const currentSortOption = document.querySelector('.current-sort-option');

  if (!sortButton || !sortDropdownMenu || !sortOptions.length || !sortSelect) return;

  // Show/hide dropdown when button is clicked
  sortButton.addEventListener('click', function() {
    if (sortDropdownMenu.style.display === 'none' || !sortDropdownMenu.style.display) {
      sortDropdownMenu.style.display = 'block';
    } else {
      sortDropdownMenu.style.display = 'none';
    }
  });

  // Hide dropdown when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.custom-sort-dropdown')) {
      sortDropdownMenu.style.display = 'none';
    }
  });

  // Handle option selection
  sortOptions.forEach(option => {
    option.addEventListener('click', function() {
      const value = this.getAttribute('data-value');
      const text = this.querySelector('span:not(.checkmark)').textContent;

      // Update the select element
      sortSelect.value = value;

      // Update the current sort option text
      if (currentSortOption) {
        currentSortOption.textContent = text;
      }

      // Update active state
      sortOptions.forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');

      // Update checkmarks
      sortOptions.forEach(opt => {
        const checkmark = opt.querySelector('.checkmark');
        if (checkmark) {
          checkmark.textContent = '';
        }
      });
      const checkmark = this.querySelector('.checkmark');
      if (checkmark) {
        checkmark.textContent = '✓';
      }

      // Hide dropdown
      sortDropdownMenu.style.display = 'none';

      // Trigger change event on select to apply sorting
      const event = new Event('change', { bubbles: true });
      sortSelect.dispatchEvent(event);
    });
  });
}

function initSearchFunctionality() {
  // The search functionality is now handled by collection-search.js
  // This function is kept for backward compatibility
}
